import safeUrl from "@/components/features/widgets/safe-url.js";

export default {
	name	: "topbar-widget",
	props	: {
		widget: {
			type		: Object,
			required	: true,
		},
	},
	computed: {
		variables() {
			return this.widget && this.widget.variables ? this.widget.variables : {};
		},
		text() {
			return this.variables.text || "";
		},
		linkUrl() {
			return safeUrl(this.variables.linkUrl);
		},
		bgColor() {
			return this.variables.bgColor || "#D5F174";
		},
		closable() {
			return this.variables.closable !== false;
		},
		rootStyle() {
			return {
				backgroundColor : this.bgColor,
			};
		},
	},
	methods: {
		onDismiss() {
			this.$emit("dismiss");
		},
	},
};
